<template>
  <div id="nav" :class="[hideNav ? 'hide-nav' : '', mobileNavNeeded ? 'mobile-is-on' : '', mobileNavOpen ? 'mobile-is-open' : '']">
    <div class="mobile-bar" v-if="mobileNavNeeded">
      <img src="@/assets/logo/logo_mobile.svg" alt="" />
      <button class='toggle-mobile' @click="mobileNavOpen = !mobileNavOpen" :class="[mobileNavOpen ? 'mobile-is-open' : '']">
        <div><img class='open' src="@/assets/icons/icon_nav-hamburger.svg" alt=""></div>
        <div><img class='close' src="@/assets/icons/icon_nav-close.svg" alt=""></div>
      </button>
    </div>
    <div class="mobile-shade" v-show="mobileNavOpen" @click="mobileNavOpen = false"/>
    <div class="mobile-wrapped" @click="mobileNavOpen = false">
      <div class="nav-holder" v-if="!mobileNavNeeded">
        <img src="@/assets/logo/logo_nav.svg" alt="" />
      </div>
      <div class="nav-items" ref="navItems" @mouseout.stop>
        <div>
          <router-link class="primary-nav" to="/home"
            ><span>Home</span></router-link
          >
          <div class="secondary">
            <router-link class="secondary-nav" to="/home/the-stadium"
              ><span>The Stadium</span></router-link
            >
          </div>
        </div>
        <div>
          <router-link class="primary-nav" to="/las-vegas-market"
            ><span>Las Vegas<br />Market</span></router-link
          >
          <div class="secondary">
            <router-link class="secondary-nav" to="/las-vegas-market/las-vegas"
              ><span>Las Vegas</span></router-link
            >
            <router-link class="secondary-nav" to="/las-vegas-market/tourism"
              ><span>Tourism</span></router-link
            >
            <router-link class="secondary-nav" to="/las-vegas-market/entertainment"
              ><span>Entertainment</span></router-link
            >            
            <router-link class="secondary-nav" to="/las-vegas-market/routing"
              ><span>Routing</span></router-link
            >          
          </div>
        </div>
        <div>
          <router-link class="primary-nav" to="/event-production"
            ><span>Event<br />Production</span></router-link          
          >
          <div class="secondary">
            <router-link class="secondary-nav" to="/event-production/seamless-load-in-load-out"
              ><span>Seamless Load In/Out</span></router-link
            >  
            <router-link class="secondary-nav" to="/event-production/seamless-load-in-load-out-highlights"
              ><span>Seamless Load In/Out Highlights</span></router-link
            >                            
            <router-link class="secondary-nav" to="/event-production/cost-savings"
              ><span>Cost Savings</span></router-link
            >  
            <router-link class="secondary-nav" to="/event-production/back-of-house"
              ><span>Back of House</span></router-link
            >        
            <router-link class="secondary-nav" to="/event-production/backstage-map"
              ><span>Backstage Map</span></router-link
            >                
            <router-link class="secondary-nav" to="/event-production/stage-configurations"
              ><span>Stage Configurations</span></router-link
            >                
          </div>
        </div>
        <div>
          <router-link class="primary-nav" to="/features-and-amenities"
            ><span>Features<br />& Amenities</span></router-link
          >
          <div class="secondary">
            <div class="has-tertiary-nav" @click="resetTertiary(); showLeadingEdgeTechnology = true;" ref="leadingEdge">
              <router-link class="secondary-nav" to="/features-and-amenities/leading-edge-technology"
                ><span>Leading Edge Technology</span><img src="@/assets/icons/icon_tert-nav-arrow.svg" alt=""></router-link
              >            
            </div>
            <div class="tertiary-nav-items" :class="[showLeadingEdgeTechnology ? 'visible' : '']">
              <router-link class="tertiary-nav" to="/features-and-amenities/leading-edge-technology/streaming-capabilities">
                <span>Streaming Capabilities</span>
              </router-link>         
              <router-link class="tertiary-nav" to="/features-and-amenities/leading-edge-technology/wifi-and-cell-coverage">
                <span>WiFi & Cell Coverage</span>
              </router-link>  
              <router-link class="tertiary-nav" to="/features-and-amenities/leading-edge-technology/cashless-payment">
                <span>Cashless Payment</span>
              </router-link>   
            </div>   
            <div>
            <router-link class="secondary-nav" to="/features-and-amenities/ticketing"
              ><span>Ticketing</span></router-link
            >
            </div>
            <div>
            <router-link class="secondary-nav" to="/features-and-amenities/etfe-roof"
              ><span>ETFE Roof</span></router-link
            >
            </div>
            <div>
              <router-link class="secondary-nav" to="/features-and-amenities/artist-vip-activations"
                ><span>Artist VIP Activations</span></router-link
              >                                        
            </div>
          </div>
        </div>
        <div>
          <router-link class="primary-nav" to="/marketing"
            ><span>Marketing</span></router-link
          >
          <div class="secondary">
              <router-link class="secondary-nav" to="/marketing/services"
                ><span>Services</span></router-link
              >                
              <router-link class="secondary-nav" to="/marketing/in-game-activations"
                ><span>In-Game Activations</span></router-link
              >
              <router-link class="secondary-nav" to="/marketing/venue-assets"
                ><span>Venue Assets</span></router-link
              >   
              <router-link class="secondary-nav" to="/marketing/digital-marketing-assets"
                ><span>Digital Marketing Assets</span></router-link
              >              
          </div>
        </div>
        <div>
          <router-link class="primary-nav" to="/getting-to-the-show"
            ><span>Getting to<br />the Show</span></router-link
          >
          <div class="secondary">              
              <router-link class="secondary-nav" to="/getting-to-the-show/walkable-from-strip"
                ><span>Walkable from Strip</span></router-link
              >
              <router-link class="secondary-nav" to="/getting-to-the-show/hacienda-bridge"
                ><span>Hacienda Bridge</span></router-link
              >
              <router-link class="secondary-nav" to="/getting-to-the-show/parking-rideshare-and-taxi"
                ><span>Parking, Rideshare & Taxi</span></router-link
              >
              <router-link class="secondary-nav" to="/getting-to-the-show/travel"
                ><span>Travel</span></router-link
              >
          </div>
        </div>
        <div>
          <router-link class="primary-nav" to="/gallery"
            ><span>Gallery</span></router-link
          >
          <div class="secondary">
            <div>
            <router-link class="secondary-nav" to="/gallery/videos"
              ><span>Videos</span></router-link
            >
            </div>           
          </div>
          <div class="secondary">
            <div class="has-tertiary-nav" @click="resetTertiary(); showExterior = true;" ref="exterior">
              <router-link class="secondary-nav" to="/gallery/exterior"
                ><span>Exterior</span><img src="@/assets/icons/icon_tert-nav-arrow.svg" alt=""></router-link
              >            
            </div>
            <div class="tertiary-nav-items" :class="[showExterior ? 'visible' : '']">
              <router-link class="tertiary-nav" to="/gallery/exterior/stadium">
                <span>Stadium</span>
              </router-link>         
              <router-link class="tertiary-nav" to="/gallery/exterior/load-in">
                <span>Load In</span>
              </router-link>                  
            </div>              
          </div>
          <div class="secondary">
            <div class="has-tertiary-nav" @click="resetTertiary(); showInterior = true;" ref="interior">
              <router-link class="secondary-nav" to="/gallery/interior"
                ><span>Interior</span><img src="@/assets/icons/icon_tert-nav-arrow.svg" alt=""></router-link
              >            
            </div>
            <div class="tertiary-nav-items" :class="[showInterior ? 'visible' : '']">
              <router-link class="tertiary-nav" to="/gallery/interior/back-of-house">
                <span>Back of House</span>
              </router-link>   
              <router-link class="tertiary-nav" to="/gallery/interior/event-floor">
                <span>Event Floor</span>
              </router-link>   
              <router-link class="tertiary-nav" to="/gallery/interior/clubs">
                <span>Clubs</span>
              </router-link>         
              <router-link class="tertiary-nav" to="/gallery/interior/concourses">
                <span>Concourses</span>
              </router-link>    
              <router-link class="tertiary-nav" to="/gallery/interior/marketing-assets">
                <span>Marketing Assets</span>
              </router-link>                   
              <router-link class="tertiary-nav" to="/gallery/interior/guest-services">
                <span>Guest Services</span>
              </router-link>                                       
            </div>              
          </div>
        </div>
      </div>
      <router-link class="contact-us" to="/contact-us"><div class="icon"><img src="@/assets/icons/icon_contact-us.svg" alt=""></div><span>Contact Us</span></router-link>             
    </div>          
  </div>
</template>

<script>
export default {
  name: "Nav",
  data: () => ({ 
    hideNav: true, 
    showLeadingEdgeTechnology:false, 
    showExterior:false,
    showInterior:false,
    mobileNavOpen:false,
    mobileNavNeeded:false,
    widthToRevertAt:700,
  }),
  components: {},
  mounted() {
    if ("" !== this.$router.currentRoute.path && "/" !== this.$router.currentRoute.path) {
      this.hideNav = false;
    }
    this.checkPath(this.$router.currentRoute.path);
    this.checkForMobileNav();
    window.addEventListener("resize", this.checkForMobileNav);
  },
  watch: {
    $route(to) {
      this.hideNav = false;
      if (to.path === "/") {
        this.hideNav = true;
      } else {
        const NavInList = this.$refs.navItems.querySelectorAll('a[href="' + to.path + '"] ~ div .secondary-nav');        
        if(NavInList !== undefined && NavInList.length !== 0) {          
          const lastNavInList = NavInList[NavInList.length - 1];
          setTimeout(function(){lastNavInList.scrollIntoView({block: "end", inline: "nearest", behavior:'smooth'});}, 250)          
        }
        const activeNavItem = this.$refs.navItems.querySelector('a[href="' + to.path + '"]');
        if(activeNavItem !== null && activeNavItem.classList.contains('secondary-nav')) {
          activeNavItem.scrollIntoView({block: "end", inline: "nearest", behavior:'smooth'});
        }
        this.checkPath(to.path);
      }
    },
  },
  updated: function() {
      this.checkForMobileNav();
      window.addEventListener("resize", this.checkForMobileNav);
  },    
  beforeDestroy: function () {
      window.removeEventListener("resize", this.checkForMobileNav);
  },
  methods: {
      checkPath(path){
        /*const tertiaryPaths = {
          'leading-edge-technology':this.showLeadingEdgeTechnology,
          'gallery/interior':this.showInterior,
          'gallery/exterior':this.showExterior,
        }
        /*
        for (const key in tertiaryPaths) {
          if (Object.hasOwnProperty.call(tertiaryPaths, key)) {
            const element = tertiaryPaths[key];
            element = false;
            
          }
        }
        */
         if(path.indexOf('leading-edge-technology') >= 0) {
          //in leading edge page
          this.showExterior = false;
          this.showInterior = false;
          this.showLeadingEdgeTechnology = true;
        } else if(path.indexOf('gallery/interior') >= 0) {
          this.showLeadingEdgeTechnology = false;
          this.showExterior = false;
          this.showInterior = true;
        } else if(path.indexOf('gallery/exterior') >= 0) {
          this.showLeadingEdgeTechnology = false;
          this.showInterior = false;
          this.showExterior = true;
        } else {
          this.showExterior = false;
          this.showInterior = false;
          this.showLeadingEdgeTechnology = false;
        }
      },
      resetTertiary() {
        this.showExterior = false;
        this.showInterior = false;
        this.showLeadingEdgeTechnology = false;
      },
     checkForMobileNav: function() {
        if(window && window.innerWidth > this.widthToRevertAt) {
            this.mobileNavNeeded = false;
        } else {
          this.mobileNavNeeded = true;
        }        
    },    
  }
};
</script>


<style lang="scss" scoped>
.mobile-shade {
  background:rgba(#0B0B0B, 0.8);
  position: absolute;
  top:0;
  left:0;
  width: 100vw;
  height:100vh;
}
.mobile-bar {
  background: linear-gradient(135deg, #232323 0%, #0C0C0C 100%);
  box-shadow: 0 10px 20px 0 rgba(0,0,0,0.2);
  padding-left:20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top:0;
  left:0;
  width: 100vw;
  box-sizing: border-box;
  z-index: 1;
}
.toggle-mobile {
  padding:20px;  
  display: grid;  
  cursor: pointer;
  background:none;
  outline:none;
  border:none;
  div {
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
  }
  img {
    transition: all 0.25s 0.1s, width 0.25s;
  }
  .close {
    opacity: 0;
  }
  &.mobile-is-open {
    .open {
      opacity: 0;
    }
    .close {
      transform: rotateZ(90deg);
      opacity: 1;
    }
  }
}
#nav {  
  display: flex;
  flex-direction: column;
  width: 0;
  opacity: 0;
  z-index: 2;
  &.hide-nav {
    transition: opacity 0.25s 0.1s, width 0.25s;
    pointer-events: none;
    overflow: hidden;
  }
  &.mobile-is-on {
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height:100%;
    .mobile-wrapped {       
      margin-top:55px;     
      transition: transform 0.25s 0.1s, width 0.25s;
      transform: translateX(calc(-100% - 15px));      
    }
    &.mobile-is-open .mobile-wrapped {
      transform: translateX(0);
    }
  }
  &:not(.hide-nav) {
    transition: opacity 0.25s 0s, width 0.25s 0.1s;

    width: 180px;
    opacity: 1;
    pointer-events: all;
  }
  .mobile-wrapped {
    background: linear-gradient(135deg, #232323 0%, #0c0c0c 100%);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
  }
  .mobile-wrapped > div:not(.mobile-bar) {
    width: 190px;
  }
}
.nav-items {
  flex-grow: 1;
  width: calc(100% + 10px);
  overflow: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
      width: 5px;
  }
  &::-webkit-scrollbar-track {
      background-color: #2E2E30;
  }
  &::-webkit-scrollbar-thumb {
      background-color: #B2B3B8;
  }
}
.nav-holder {
  text-align: center;
  padding: 50px 0;
  img {
    width: 100px;
    height: 40px;
  }
}
.secondary {
  overflow: hidden;
  max-height: 0;
  width: calc(100% - 10px);
  transition: max-height 0.25s;
  background:#0c0c0c;
}
a {
  font-family: "Gotham";
  font-size: 0.8em;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1em;
  text-decoration: none;
  user-select: none;  
  &.contact-us {
    border-radius: 0 3px 0 0;
    background: linear-gradient(180deg, #FFFFFF 0.38%, #9E9E9E 99.68%);
    color: #2E2E30;   
    padding:15px 20px;     
    .icon, span {
      vertical-align: middle;
    }  
    .icon {
      background: linear-gradient(180deg, #FFFFFF 0.38%, #9E9E9E 99.68%);
      box-shadow: 0 5px 15px 0 rgba(0,0,0,0.2);
      border-radius: 100%;
      overflow: hidden;
      width:35px;
      height:35px;
      box-sizing: border-box;
      display: inline-block;
      margin-right:15px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }      
  }
  &.primary-nav {
    text-transform: uppercase;
    height: 70px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 25px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    color: #747474;
    position: relative;
    transition: color 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
    line-height: 1.3em;
    &::before {
      content: " ";
      background-image: url("~@/assets/shapes/shape_nav.svg");
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% + 10px);
      height: 100%;
      border-bottom: 2px solid rgba(255, 255, 255, 1);
      background-color: #2d2d2d;
      pointer-events: none;
      opacity: 0;
      transform: translateX(-10px);
      transition: transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
    span {
      position: relative;
    }
    &:hover {
      color: #fff;
    }
    &.router-link-exact-active,
    &.router-link-active {
      &::before {
        opacity: 1;
        transform: translateX(0);
        box-shadow: -5px 10px 20px 0 rgba(19, 19, 19, 0.5);
      }
      span {
        background-image: linear-gradient(269deg, #f5831f 0%, #fed208 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      & ~ div {
        max-height: 450px;
      }
    }
  }
  &.secondary-nav {
    color: #4b4b4d;        
    line-height: 1.1em;
    padding: 1.4em 0;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    transition: color 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
    background-color: #232323;    
    &::before,
    span {
      vertical-align: middle;
    }
    span {
      transition: left 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
      position: relative;
      left: -20px;
      min-width: 115px;
    }
    img {
      height:10px;
      width:5px;
      float:right;
      transform:rotateZ(90deg);
    }
    &::before {
      content: " ";
      display: inline-block;
      height: 4px;
      width: 4px;
      background:#fff;
      box-shadow: 0 0 6px 0 #fff;
      border-radius: 100%;
      margin-right: 15px;
      opacity: 0;
      transition: opacity 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
      flex-grow: 0;
      flex-shrink: 0;
    }
    &:hover {
      color: #fff;
    }
    &.router-link-active,
    &.router-link-exact-active {
      background-color: #242424;
      span {        
        color:#fff;
      }
      &::before {
        opacity: 1;
      }
      span {
        left: 0;
      }
    }
  }  
  &.tertiary-nav {
    color: #FFFFFF;              
    background: linear-gradient(315deg, #2B2B2B 0%, #191919 100%);
    padding: 1.4em 0;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    position: relative;
    span {
      position: relative;
      z-index: 1;
    }
    &::before {
      content:" ";
      background: linear-gradient(315deg, #484848 0%, #2F2F2F 100%);
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    &.router-link-exact-active,
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
}
.tertiary-nav-items {    
    transition: max-height 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    pointer-events: none;
    max-height: 0;
    overflow: hidden;
    &.visible {
      max-height: 350px;
      pointer-events: all;
    }
  }
.has-tertiary-nav {        
  .secondary-nav {
    margin-bottom:1px;    
  }
}
.secondary {
  a {
    margin-bottom:1px;
  }
  > * {
    a {
      margin-bottom:1px;
    }
    &:last-child {
      a {
        margin-bottom: 0;
      }
    }
  }
}
</style>
